





































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency";
import InvestmentInstrumentPieChart from "@/shared/components/charts/InvestmentInstrumentPieChart.vue";
import DrivewealthNavigation from "@/shared/components/investments/drivewealth/DrivewealthNavigation.vue";
import InvestWithDrivewealthWidget from "@/employee/components/investments/drivewealth/InvestWithDrivewealthWidget.vue";
import PreenrollmentWidget from "@/employee/components/investments/drivewealth/PreenrollmentWidget.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import RiskDisclaimer from "@/shared/components/investments/drivewealth/RiskDisclaimer.vue";
import UserPartnerContent from "@/employee/components/investments/drivewealth/UserPartnerContent.vue";
import PreenrollmentManagement from "@/shared/components/investments/drivewealth/PreenrollmentManagement.vue";
import AccountTypeSubheader from "@/employee/components/investments/drivewealth/AccountTypeSubheader.vue";
import HsabInvestmentAccountRedirectLink from "@/shared/components/investments/HsabInvestmentAccountRedirectLink.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import {
  DrivewealthAccountManagementType,
  ChartPointDataType,
  GenericChartValueType,
  DrivewealthAccountIdentifierArgs,
  DrivewealthAccountPerformance,
  DrivewealthAccountRateOfReturnModel,
  GenericGraphPoint,
  DrivewealthAccountPerformanceTimePeriod,
  GenericBarChartDataPoint,
} from "@/shared/types";
import { useDrivewealthSweepStore } from "@/shared/store/drivewealthSweep";
import { useDrivewealthAccountPerformanceStore } from "@/shared/store/drivewealthAccountPerformance";
import AccountPerformanceForm from "@/employee/components/investments/drivewealth/AccountPerformanceForm.vue";
import InvestmentBalancePanel from "@/shared/components/investments/drivewealth/InvestmentBalancePanel.vue";
import moment from "moment";
import GenericLineChart from "@/shared/components/charts/GenericLineChart.vue";
import _ from "lodash";
import GenericBarChart from "@/shared/components/charts/GenericBarChart.vue";
import LegalEntity from "@/shared/legalEntity";

enum GraphType {
  balance,
  rateOfReturn,
  holdings
}

@Component({
  components: {
    GenericBarChart,
    GenericLineChart,
    AccountPerformanceForm,
    InvestmentBalancePanel,
    DrivewealthNavigation,
    InvestmentInstrumentPieChart,
    GenericLoadingSpinner,
    InvestWithDrivewealthWidget,
    RiskDisclaimer,
    UserPartnerContent,
    PreenrollmentWidget,
    PreenrollmentManagement,
    AccountTypeSubheader,
    HsabInvestmentAccountRedirectLink,
  },
  computed: {
    ChartPointDataType () {
      return ChartPointDataType;
    },
    GenericChartValueType () {
      return GenericChartValueType;
    },
    GraphType () {
      return GraphType;
    }
  }
})
export default class DrivewealthAccountSummaryView extends Vue {
  drivewealthStore = useDrivewealthStore();
  investmentDailyBalanceStore = useInvestmentDailyBalanceStore();
  drivewealthWizardStore = useDrivewealthWizardStore();
  signingDocumentStore = useSigningDocumentStore();
  custodianSettingsStore = useCustodianSettingsStore();
  drivewealthSweepStore = useDrivewealthSweepStore();
  drivewealthAccountPerformanceStore = useDrivewealthAccountPerformanceStore();

  DrivewealthAccountManagementType = DrivewealthAccountManagementType;
  formatCurrency = formatCurrency;
  selectedGraphType = GraphType.balance;

  graphTypeSelectOptions = [
    {
      text: "Balance",
      value: GraphType.balance,
    },
    {
      text: "Rate of Return",
      value: GraphType.rateOfReturn,
    },
    {
      text: "Allocations",
      value: GraphType.holdings,
    }
  ];

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ required: true })
  accountId: number;

  load (): void {
    this.investmentDailyBalanceStore.loadHsaBalanceAndThreshold({});
    this.drivewealthSweepStore.getSweepV2({});
    this.drivewealthWizardStore.loadExistingPreenrollment({});
    this.drivewealthWizardStore.loadAllowedInvestmentAccountTypes({});
    this.drivewealthStore.loadAccountSummariesV2({});
    this.loadChartData();
  }

  @Watch("accountId")
  reload (): void {
    this.setSelectedGraph(GraphType.balance);
    this.load();
  }

  @Watch("selectedGraphType")
  loadRateOfReturnData (newValue: GraphType): void {
    if (newValue === GraphType.rateOfReturn) {
      this.drivewealthAccountPerformanceStore.getRateOfReturn(this.accountIdentifiers);
    }
  }

  mounted (): void {
    this.load();
  }

  loadChartData () {
    this.drivewealthAccountPerformanceStore.getAccountPerformance(this.accountIdentifiers);
    this.drivewealthAccountPerformanceStore.getInvestmentBalanceGraphData(this.accountIdentifiers);

  }

  get divisionName () {
    return LegalEntity.divisionName;
  }

  get accountIdentifiers (): DrivewealthAccountIdentifierArgs {
    return {
      username: this.username,
      partnerId: this.partnerId,
      accountId: this.accountId
    };
  }

  get showLoadingSpinner (): boolean {
    return !this.isLoaded;
  }

  get rateOfReturnDataLoaded (): boolean {
    return this.drivewealthAccountPerformanceStore.rateOfReturnLoaded(this.accountId);
  }

  get accountPerformanceDataLoaded (): boolean {
    return this.drivewealthAccountPerformanceStore.accountPerformanceLoaded(this.accountIdentifiers);
  }

  get isLoaded (): boolean {
    return this.investmentDailyBalanceStore.isHsaBalanceAndThresholdLoaded &&
        this.drivewealthSweepStore.sweepLoaded &&
        this.drivewealthStore.accountSummaryV2Loaded(this.accountId);
  }

  get showPreenrollment (): boolean {
    return !this.investmentDailyBalanceStore.hasEnoughToOpenAccount &&
        this.drivewealthWizardStore.isAllowedToPreenroll;
  }

  get accountPerformanceResult (): DrivewealthAccountPerformance {
    return this.drivewealthAccountPerformanceStore.accountPerformanceResult(this.accountIdentifiers);
  }

  get rateOfReturnResult (): DrivewealthAccountRateOfReturnModel {
    return this.drivewealthAccountPerformanceStore.rateOfReturnResult(this.accountId);
  }

  get isAccountPerformanceResultEmpty (): boolean {
    return this.accountPerformanceResult && !!this.accountPerformanceResult.emptyDataSetMessage;
  }

  get isRateOfReturnResultEmpty (): boolean {
    return this.rateOfReturnResult && !!this.rateOfReturnResult.emptyDataSetMessage;
  }

  get displayAccountPerformanceErrorMessage (): boolean {
    return (this.isAccountPerformanceResultEmpty || this.isRateOfReturnResultEmpty) && !this.chartDataSet.length;
  }

  get graphDataLoaded (): boolean {
    return this.drivewealthAccountPerformanceStore.accountPerformanceLoaded(this.accountIdentifiers) &&
        this.drivewealthAccountPerformanceStore.investmentBalanceGraphDataLoaded(this.accountIdentifiers);
  }

  get graphDateFormat (): string {
    switch ( this.drivewealthAccountPerformanceStore.selectedTimePeriod) {
      case DrivewealthAccountPerformanceTimePeriod.Months1:
        return "EE MM/dd";
      case DrivewealthAccountPerformanceTimePeriod.YearToDate:
        return "MM/dd";
      case DrivewealthAccountPerformanceTimePeriod.Years1:
        return "MM/yy";
      case DrivewealthAccountPerformanceTimePeriod.Max:
        return "MM/yy";
      default:
        return "MM/dd";
    }
  }

  get chartDataSet (): GenericGraphPoint[] {
    const graphData = this.drivewealthAccountPerformanceStore.investmentBalanceGraphData(this.accountIdentifiers);
    let accountPerformanceChartDataItems: GenericGraphPoint[] = [];
    if (graphData && !!graphData.length) {
      accountPerformanceChartDataItems = _.map(graphData, x => {

        return {
          value: x.balance,
          date: moment(x.date).format("DD-MMM-YY"),
        };
      });
    }

    return accountPerformanceChartDataItems;
  }

  get rateOfReturnBarChartData (): GenericBarChartDataPoint[] {
    const rateOfReturnData = this.drivewealthAccountPerformanceStore.rateOfReturnResult(this.accountId);

    if (rateOfReturnData.emptyDataSetMessage) {
      return [];
    }

    const accountSummary = this.drivewealthStore.accountSummaryById(this.accountId);

    const mappedValues = [
      {
        label: "MTD",
        value: rateOfReturnData.mtdRateOfReturn,
        firstValidDate: moment()
      },
      {
        label: "1 M",
        value: rateOfReturnData.oneMonthRateOfReturn,
        firstValidDate: moment().add(-1, "months")
      },
      {
        label: "3 M",
        value: rateOfReturnData.threeMonthRateOfReturn,
        firstValidDate: moment().add(-3, "months")
      },
      {
        label: "6 M",
        value: rateOfReturnData.sixMonthRateOfReturn,
        firstValidDate: moment().add(-6, "months")
      },
      {
        label: "YTD",
        value: rateOfReturnData.ytdRateOfReturn,
        firstValidDate: moment()
      },
      {
        label: "1 Y",
        value: rateOfReturnData.oneYearRateOfReturn,
        firstValidDate: moment().add(-1, "years")
      },
      {
        label: "Max",
        value: rateOfReturnData.inceptionRateOfReturn,
        firstValidDate: moment()
      },
    ];

    const validDataPoints = mappedValues.filter(x => moment(accountSummary.dateCreated).isBefore(x.firstValidDate));

    return validDataPoints.map(x => ({ label: x.label, value: x.value }));
  }

  get lastUpdatedAccountPerformanceDate (): string {
    if (!this.accountPerformanceResult) {
      return "Not available.";
    }

    return moment(this.accountPerformanceResult.lastUpdated).format("MM/DD/YYYY");
  }

  get inceptionReturn (): number {
    if (!this.accountPerformanceResult) {
      return 0;
    }

    return this.accountPerformanceResult.inceptionReturn;
  }

  get isInceptionReturnNegative (): boolean {
    return this.inceptionReturn < 0;
  }

  setSelectedGraph (graphType: GraphType): void {
    this.selectedGraphType = graphType;
  }
}
